export default {
	"fe06c7d68480f0fa88aa753997d9cac2": "抱歉，價格已發生變化!",
	"fa27089ef054b4a53682eaa0249d2990": "系統錯誤,請稍後再試",
	"4176f4a3daa3decf0f41f77c228867f5": "簽約失敗,請重新簽約"
}
